import { FC } from "react";
import { Trans } from "@lingui/macro";
import { CurrencyInput } from "src/atoms/Input";
import { RangeText } from "./PriceInputs.styled";

interface Props {
  range: string[];
  onInputChange: (
    index: number
  ) => (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const PriceInputs: FC<Props> = ({ range, onInputChange }) => (
  <>
    <CurrencyInput
      value={range[0]}
      onChange={onInputChange(0)}
      data-testid="price-filter-min-price"
    />
    <RangeText mx={3} fontSize={1} color="tone.black">
      <Trans>till</Trans>
    </RangeText>
    <CurrencyInput
      value={range[1]}
      onChange={onInputChange(1)}
      data-testid="price-filter-max-price"
    />
  </>
);

export default PriceInputs;
